var exports = {
  "lI": "fieldset__wFMYEX",
  "o1": "legend__Bkj58t",
  "pG": "caption__LDkFmH",
  "Ge": "rows__tkpnZk",
  "nM": "row__vKkNUY",
  "TF": "remove__8RqMri",
  "ZZ": "field__39qMzx",
  "WQ": "add__usr8RI",
};

module.exports = exports;
